import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M197.88 375.65h184.04c54.33 0 98.38-44.05 98.38-98.38 0-78.13-95.93-121.11-146.77-70.27l-98.14 98.05M341.08 305.48l-104.27-97.65",
  class: "cls-2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M288.13 172.17c0-45.03-36.5-81.53-81.53-81.53s-81.53 36.5-81.53 81.53c0 4.29.33 8.51.97 12.62-4.11-.64-8.33-.97-12.62-.97-45.03 0-81.53 36.5-81.53 81.53s36.5 81.53 81.53 81.53c41.07 0 75.05-30.37 80.71-69.88h-92.35",
  style: {"stroke":"#fff","fill":"none","stroke-miterlimit":"10","stroke-width":"35.77px"}
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [
          _createTextVNode(".cls-2{fill:none;stroke-miterlimit:10;stroke-width:35.77px;stroke:#b6489b}")
        ]),
        _: 1
      }))
    ]),
    _hoisted_2,
    _hoisted_3
  ]))
}
export default { render: render }